module.exports = __webpack_public_path__ + "static/media/azaumicon.870ee2a2.png";